import { createContext, useState } from 'react';

import { BASIC_INITIAL_STATE } from '@usas/ui-web/utils/HttpHelper';

export const AccountManagementEmailStateContext = createContext();

const INITIAL_STATE = {
  ...BASIC_INITIAL_STATE
};

const AccountManagementEmailContextProvider = ({ children }) => {
  const stateHook = useState(INITIAL_STATE);

  return (
    <AccountManagementEmailStateContext.Provider value={stateHook}>
      {children}
    </AccountManagementEmailStateContext.Provider>
  );
};

export default AccountManagementEmailContextProvider;